import React from "react";

import "./LAYOUT_GLOBAL.scss";

const classes = require("./Layout.module.scss");

const Layout = (props: { children: any }) => {
    const combinedClasses = [classes.background, classes.containRow].join("");
    return <div className={combinedClasses}>{props.children}</div>;
};

export default Layout;
